module.exports = __webpack_public_path__ + "media/images/dashboard/marker-e3edd08de4ace67c8f06434935b019ba.svg";